module.exports = __webpack_public_path__ + "static/fonts/montserrat-semibold.c88cecb.ttf";